import React from 'react'
import { useTheme } from '@mui/material/styles'
import { DataGridPro, gridClasses, GridColDef } from '@mui/x-data-grid-pro'
import { getMuiDataGridLocaleText } from '../../../i18n/localeUtils'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import * as datefns from 'date-fns'
import { CustomDataGridToolbar } from '../../../components/custom-grid-components/CustomDataGridToolbar'
import { CustomerEntity } from 'types/CustomerEntity'

const customersColumns = (): Array<GridColDef<CustomerEntity>> => [
    {
        field: 'name',
        headerName: 'Namn',
        minWidth: 150,
        flex: 1,
        renderCell: ({ row: customer, value: name }) => {
            return <Link to={`/admin/customers/${customer.id}`}>{name}</Link>
        },
    },
    {
        field: 'userCount',
        headerName: 'Aktiverade användare (totalt)',
        minWidth: 150,
        flex: 1,
        valueGetter: (_, customer) => {
            return customer.totalUserCount - customer.disabledUserCount
        },
        renderCell: ({ row: customer }) => {
            return `${customer.totalUserCount - customer.disabledUserCount} (${customer.totalUserCount})`
        },
    },
    {
        field: 'lastActive',
        headerName: 'Senast aktiv',
        minWidth: 150,
        flex: 1,
        valueFormatter: (value) => (value ? datefns.format(new Date(value), 'yyyy-MM-dd HH:mm:ss') : ''),
    },
    // { field: 'totalUserCount', headerName: 'Totalt antal användare', minWidth: 150, flex: 1 },
    // { field: 'disabledUserCount', headerName: 'Inaktiverade användare', minWidth: 150, flex: 1 },
]

function CustomersGrid({ customers }: { customers: CustomerEntity[] }) {
    const { i18n } = useTranslation()
    const locale = i18n.language

    const disableSelectedSellOutlineStyle = {
        [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
            outline: 'none',
        },
        [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]: {
            outline: 'none',
        },
    }
    const theme = useTheme()

    return (
        <div style={{ width: '100%' }}>
            <DataGridPro
                sx={{
                    ...disableSelectedSellOutlineStyle,
                    width: '100%',
                    '& .even': {
                        backgroundColor: theme.palette.rowColor.main, // Use palette color for even rows
                    },
                    '& .odd': {
                        // backgroundColor: theme.palette.rowColor.light, // Use palette color for odd rows
                    },
                }}
                rows={customers}
                columns={customersColumns()}
                localeText={getMuiDataGridLocaleText(locale)}
                // Use the custom toolbar
                slots={{ toolbar: CustomDataGridToolbar }}
                getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd')}
                // Disable column filter options
                disableColumnFilter
                // Disable column menu
                disableColumnMenu
                // Disable row selection on click
                disableRowSelectionOnClick
                showToolbar
            />
        </div>
    )
}

export default CustomersGrid
